import { Anchor, Box, Button, Container, Stack, Text, Title } from "@mantine/core";
import { ErrorComponent, type ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { contactHelpAddress } from "@/configs/contactInformation";
import { useEnv } from "@/hooks/useEnv";
import { useNavigationAnonymous } from "@/hooks/useNavigation";
import Icon from "@/utils/icons";

import styles from "./RouterError.module.css";

export const RouterError = ({ error }: ErrorComponentProps) => {
  const env = useEnv("VITE_ENV");
  const { t } = useTranslation();
  const { goToDashboard } = useNavigationAnonymous();

  // Log error to console for debugging
  // Note: Sentry will automatically capture this via tanstackRouterBrowserTracingIntegration
  // and supabaseIntegration, so we don't need to manually call captureException here
  useEffect(() => {
    console.error(`RouterError:`, error);
    console.error(`RouterError | Instance check:`, error instanceof Error);
  }, [error]);

  return (
    <Container>
      <Box pos="relative">
        <Stack pt="16vh" maw={900} mx="auto" align="center">
          <Icon.FILE_MISSING className={styles.icon} />
          <Title order={3} ta="center" mb="md">
            {t("500.title")}
          </Title>
          <Text c="dimmed" size="md" ta="center">
            {t("500.text")}

            <Anchor href={`mailto:${contactHelpAddress}`} target="_blank">
              {contactHelpAddress}
            </Anchor>
          </Text>

          {env === "localhost" && <ErrorComponent error={error} />}

          <Button onClick={goToDashboard}>{t("500.button")}</Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default RouterError;
